<template>
  <b-container class="align-items-center" style="margin-top:20px; max-width: 800px; color: #777;">
    <div>
      <span style="font-weight: bold; font-size: 2em; text-align: center;color: steelblue"><a target="_new" href="https://www.initekconsulting.com/fleet-integrations"><img style="margin-top:-5px" width="40" src="favicon.ico"/></a> Fleet Integrations - Register Your Company</span>
      <div style="text-align: center; font-weight: bold; font-size: 18px; margin:20px; padding: 10px; border: 1px dotted steelblue">
        <h4 style="margin:10px">Provide the following information to start the process<br/> and we'll contact you setup the following features.</h4>
        <hr width="90%"/>
      Features: <a href="https://www.initekconsulting.com/booking-actuals">Actuals</a>
        |&nbsp;<a href="https://www.initekconsulting.com/booking-views-reports">Reports</a>
        |&nbsp;<a href="https://www.initekconsulting.com/alerts-notifications">Alerts</a>
        |&nbsp;<a href="https://www.initekconsulting.com/vehicle-status-mgr">Vehicle Status</a>
        |&nbsp;<a href="https://www.initekconsulting.com/data-access">Data Access</a>
        |&nbsp;<a href="https://www.initekconsulting.com/bus-sos">Bus SOS</a>
        <br/>
        More Info: <a href="https://www.initekconsulting.com/pricing">Pricing</a>&nbsp;|&nbsp;<a href="mailto:support@initekconsulting.com">Contact Us</a>
      </div>
      <div style="text-align: center; font-weight: bold; font-size: 18px; margin:20px; padding: 10px; border: 1px dotted steelblue">
        <b-form @submit.prevent="register">
          <div style="margin-left:10px; text-align: left;font-style: italic;color: steelblue">Company Info</div>
          <div style="margin:10px" class="d-flex align-items-center justify-content-center" >
            <span style="width:300px; font-weight: bold">Company Name:</span>
            <span style="width:300px"><b-form-input v-model="form.company_name" type="text"/></span>
          </div>
          <div style="margin:10px" class="d-flex align-items-center justify-content-center" >
            <span style="width:300px; font-weight: bold">Time Zone:</span>
            <span style="width:300px"><b-form-select v-model="form.timezone" :options="timezone_options"></b-form-select></span>
          </div>
          <hr width="90%"/>
          <div style="margin-left:10px; text-align: left;font-style: italic;color: steelblue">Primary Contact Info</div>
          <div style="margin:10px" class="d-flex align-items-center justify-content-center" >
            <span style="width:300px; font-weight: bold">Full Name:</span>
            <span style="width:300px"><b-form-input v-model="form.contact_name" type="text"/></span>
          </div>
          <div style="margin:10px" class="d-flex align-items-center justify-content-center" >
            <span style="width:300px; font-weight: bold">Email Address:</span>
            <span style="width:300px"><b-form-input v-model="form.username" type="text"/></span>
          </div>
          <div style="margin:10px" class="d-flex align-items-center justify-content-center" >
            <span style="width:300px; font-weight: bold">Phone Number:</span>
            <span style="width:300px"><b-form-input v-model="form.phone" type="text"/></span>
          </div>
          <hr width="90%"/>
          <div style="margin-left:10px; text-align: left;font-style: italic;color: steelblue">Integration Needs</div>
          <div style="margin:20px" class="d-flex align-items-center justify-content-center" >
            <span style="width:300px; font-weight: bold">How Many Vehicles Do You Have?</span>
            <span style="width:300px"><b-form-select v-model="form.vehicle_count" :options="vehicle_count_options"></b-form-select></span>
          </div>
          <div style="margin:20px" class="d-flex align-items-center justify-content-center" >
            <span style="width:300px; font-weight: bold">What Features Are You Interest In?</span>
            <span style="width:300px"><b-form-select v-model="form.features" :options="feature_options" multiple :select-size="feature_options.length"></b-form-select></span>
          </div>
<!--          <div style="margin:20px" class="d-flex align-items-center justify-content-center" >-->
<!--            <span style="width:300px; font-weight: bold">Type Of Vehicles:</span>-->
<!--            <span style="width:300px"><b-form-select v-model="form.vehicle_types" :options="vehicle_type_options" multiple select-size=5></b-form-select></span>-->
<!--          </div>-->
          <div style="margin:20px" class="d-flex align-items-center justify-content-center" >
            <span style="width:300px; font-weight: bold">Are You Interested In Integrating Your Booking Platform?</span>
            <span style="width:300px"><b-form-select v-model="form.booking_manager" :options="booking_manager_options"></b-form-select></span>
          </div>
          <div style="margin:20px" class="d-flex align-items-center justify-content-center" >
            <span style="width:300px; font-weight: bold">Are You Interested Integrating Your Vehicle Telematics Platform?</span>
            <span style="width:300px"><b-form-select v-model="form.telematics_type" :options="telematics_options"></b-form-select></span>
          </div>
<!--          <div v-if="form.telematics_type == 'SAMSARA'" style="border: 1px dotted lightslategrey">-->
<!--            <div style="text-align: center; margin:20px;color: steelblue">-->
<!--              <b>Configure Samsara Access (can be done later)&nbsp;&nbsp;-->
<!--                <b-button variant="success" size="sm" v-if="form.booking_manager != ''" @click="view_samsara_booking_setup = !view_samsara_booking_setup">view instructions</b-button>-->
<!--                <b-button variant="success" size="sm" v-else @click="view_samsara_setup = !view_samsara_setup">view instructions</b-button>-->
<!--              </b>-->
<!--            </div>-->
<!--            <div style="margin:20px" class="d-flex align-items-center justify-content-center" >-->
<!--              <span style="width:300px; font-weight: bold">Samsara API Key:</span>-->
<!--              <span style="width:300px"><b-form-input v-model="form.samsara_api_key" type="text"/></span>-->
<!--            </div>-->
<!--            <div style="margin:20px" class="d-flex align-items-center justify-content-center" >-->
<!--              <span style="width:300px; font-weight: bold">Samsara Group ID:</span>-->
<!--              <span style="width:300px"><b-form-input v-model="form.samsara_group_id" type="text"/></span>-->
<!--            </div>-->
<!--            <div style="margin:20px" class="d-flex align-items-center justify-content-center" >-->
<!--              <span style="width:300px; font-weight: bold">Samsara Org ID:</span>-->
<!--              <span style="width:300px"><b-form-input v-model="form.samsara_org_id" type="text"/></span>-->
<!--            </div>-->
<!--          </div>-->
          <div v-if="form.telematics_type == '' && form.features.includes('bus_sos')" style="border: 1px dotted lightslategrey">
            <div style="text-align: center; margin:20px; color: steelblue">
              <b>Add A Vehicle Yard (can be managed later)</b>
            </div>
            <div style="margin:20px" class="d-flex align-items-center justify-content-center" >
              <span style="width:300px; font-weight: bold">Yard Name:</span>
              <span style="width:300px"><b-form-input v-model="form.yard_name" type="text"/></span>
            </div>
            <div style="margin:20px" class="d-flex align-items-center justify-content-center" >
              <span style="width:300px; font-weight: bold">Yard Full Address:</span>
              <span style="width:300px"><b-form-textarea v-model="form.yard_address" style="field-sizing: content"/></span>
            </div>
          </div>
          <hr width="90%"/>
          <div style="margin-left:10px; text-align: left;font-style: italic;color: steelblue">Question / Comments</div>
          <div style="margin:20px" class="d-flex align-items-center justify-content-center" >
            <span style="width:600px"><b-form-textarea v-model="form.comments" style="field-sizing: content"/></span>
          </div>
          <div style="margin:20px">
            <span style="width:300px; font-weight: bold">&nbsp;</span>
            <span style="width:300px">
              <b-button id="login-button" type="submit" size="lg">Submit Registration</b-button>
            </span>
          </div>
          <hr width="80%"/>
          <div style="margin:10px; text-align: left">
            <span style="font-size: 16px; color: steelblue; font-style: italic">
                you will be contacted by our support team to complete your setup
            </span>
          </div>
        </b-form>
      </div>
      <br/>
      <div class="text-center">
        <router-link style="font-weight: bold; font-size: 20px;" :to="{ path: '/login' }">Login</router-link>
        &nbsp;&nbsp;|&nbsp;&nbsp;
        <a style="font-weight: bold; font-size: 20px;" target="_new" href="https://www.initekconsulting.com/fleet-integrations">Info</a>
        &nbsp;&nbsp;|&nbsp;&nbsp;
        <a style="font-weight: bold; font-size: 20px" href="mailto:support@initekconsulting.com">Contact Us</a>
      </div>
    </div>
    <b-modal title="Samsara Setup Steps" size="xl" v-model="view_samsara_setup" ok-only>
      <h4>The following steps will provide access to data required for your selected features</h4>
      <ul>
        <li>log into Samsara and go to Settings → DEVELOPER → API Tokens</li>
        <li>click create ‘Add an API Token’ in the top right</li>
        <li>name the token ‘Fleet Integrations'</li>
        <li>under Scopes
          <ul>
            <li>clear the default permissions by selecting and then unselecting the options under Global → Global Read and Global → Global Write</li>
            <li>then set only the following permissions
              <ul>
                <li>Drivers → Read Drivers</li>
                <li>Vehicles → Read Vehicles</li>
                <li>Vehicles → Read Vehicle Statistics</li>
                <li>Vehicles → Read Vehicle Trips</li>
              </ul>
            </li>
          </ul>
        </li>
        <li>copy the API key (it is only shown once for security reasons) and set the value below</li>
        <li>also, copy the Org ID & Group ID values (found on the API Tokens page under 'Developer Documentation and Guides' section)</li>
      </ul>
    </b-modal>
    <b-modal title="Samsara With Booking Manager Steps" size="xl" v-model="view_samsara_booking_setup" ok-only>
      <h4>The following steps will provide access to data required for your selected features</h4>
      <ul>
        <li>log into Samsara and go to Settings → DEVELOPER → API Tokens</li>
        <li>click create ‘Add an API Token’ in the top right</li>
        <li>name the token ‘Fleet Integrations'</li>
        <li>under Scopes
          <ul>
            <li>clear the default permissions by selecting and then unselecting the options under Global → Global Read and Global → Global Write</li>
            <li>then set only the following permissions
              <ul>
                <li>Compliance → Read ELD Hours of Service</li>
                <li>Compliance → Read ELD Compliance Settings</li>
                <li>Driver Workflow (if routing is enabled) → Routes → Read</li>
                <li>Driver Workflow (if routing is enabled) → Routes → Write</li>
                <li>Drivers → Read Drivers</li>
                <li>Equipment → Read Equipment Statistics</li>
                <li>Maintenance → Read DVIR</li>
                <li>Setup & Administration → Read Gateways</li>
                <li>Vehicles → Read Vehicles</li>
                <li>Vehicles → Read Vehicle Statistics</li>
                <li>Vehicles → Read Vehicle Trips</li>
              </ul>
            </li>
          </ul>
        </li>
        <li>copy the API key (it is only shown once for security reasons) and set the value below</li>
        <li>also, copy the Org ID & Group ID values (found on the API Tokens page under 'Developer Documentation and Guides' section)</li>
      </ul>
    </b-modal>

    <div style="color: #007ac7; font-family: 'inherit' ;font-size: 24px; margin:50px 0px 50px 0px; padding:20px; border-top: 2px dotted #ccc;">
      powered by &#8594; <a target="_new" href="https://www.initekconsulting.com/fleet-integrations"><img height="40" src="/initek-logo.png"/></a>
    </div>

  </b-container>
</template>

<script>

import {register_tenant} from "../networking/apis";

export default {
  name: 'direct_register',
  components: {
  },

  data() {
    return {
      view_samsara_setup: false,
      view_samsara_booking_setup: false,
      form: { features: [] },
      feature_options: [
        { text: 'Actuals Integration', value: 'booking_actuals' },
        { text: 'Views & Reports', value: 'booking_views' },
        { text: 'Alerts & Notifications', value: 'booking_alerts' },
        { text: 'Vehicle Status Management', value: 'veh_status_mgmt' },
        { text: 'Data Integrations', value: 'data_services' },
        { text: 'Bus SOS', value: 'bus_sos' },
      ],
      booking_manager_options: [
        { text: 'Not At This Time', value: '' },
        { text: 'Yes, With Distinctive Coach Manager', value: 'CM' },
        { text: 'Yes, With TBN OpsDriver', value: 'TBN' },
      ],
      telematics_options: [
        { text: 'Not At This Time', value: '' },
        { text: 'Yes, With Samsara', value: 'SAMSARA' },
        { text: 'Yes, With Saucon', value: 'SAUCON' },
        { text: 'Yes, With Motive', value: 'MOTIVE' },
        { text: 'Yes, With Zonar', value: 'ZONRA' },
        { text: 'Yes, With Another Provider', value: 'OTHER' },
      ],
      vehicle_count_options: [
        { text: 'Less Than 10', value: '10' },
        { text: '10 - 50', value: '10+' },
        { text: '50 - 100', value: '50+' },
        { text: '100+', value: '100+' },
      ],
      vehicle_type_options: [
        { text: 'Full Size', value: 'full' },
        { text: 'Mini', value: 'mini' },
        { text: 'Sprinter', value: 'sprinter' },
        { text: 'SUV', value: 'suv' },
        { text: 'Other', value: 'other' },
      ],
      timezone_options: [
        { text: 'US/Pacific', value: 'US/Pacific' },
        { text: 'US/Mountain', value: 'US/Mountain' },
        { text: 'US/Central', value: 'US/Central' },
        { text: 'US/Eastern', value: 'US/Eastern' },
        { text: 'America/Phoenix', value: 'America/Phoenix' },
        { text: 'America/New_York', value: 'America/New_York' },
        { text: 'America/Chicago', value: 'America/Chicago' },
        { text: 'Other', value: '' },
      ]
    }
  },
  async created() {
    localStorage.clear()
  },
  methods: {
    async register() {
      await register_tenant(this.form)
      window.location.href = 'https://web.fleet-integrations.com';
    },
  }
}
</script>

